import { FadeUp } from "@/components/motion/Reveal";
import { IMAGES, TRUST } from "@/data/site";

export default function About() {
  return (
    <section id="hakkimizda" className="bg-ivory py-20 sm:py-28" data-testid="about-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* images collage */}
        <div className="lg:col-span-6 relative">
          <FadeUp>
            <div className="img-zoom rounded-3xl overflow-hidden aspect-[4/3]">
              <img
                src={IMAGES.salonInterior}
                alt="Hülya Suna Beauty salon iç mekânı"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
          </FadeUp>
          <FadeUp delay={0.12}>
            <div className="img-zoom absolute -bottom-10 right-4 w-40 sm:w-56 rounded-2xl overflow-hidden aspect-[3/4] border-4 border-ivory shadow-lg hidden sm:block">
              <img
                src={IMAGES.salonInterior2}
                alt="Salon detay görseli"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
          </FadeUp>
        </div>

        {/* text */}
        <div className="lg:col-span-6">
          <FadeUp>
            <p className="eyebrow text-gold mb-4">Hakkımızda</p>
          </FadeUp>
          <FadeUp delay={0.05}>
            <h2 className="font-serif text-espresso text-4xl sm:text-5xl lg:text-6xl leading-[1.03] mb-6">
              Güzelliğe <span className="italic">Kişisel Bir Dokunuş</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.1}>
            <p className="text-espresso/70 leading-relaxed max-w-xl mb-8">
              Hülya Suna Beauty’de her uygulama, kişinin ihtiyacına ve stiline göre ele
              alınır. Kuaför, güzellik bakımı ve özel gün hazırlığını aynı çatı altında
              buluşturan yaklaşımımızla; kendinizi rahat, özenli ve özel hissedeceğiniz bir
              deneyim sunmayı amaçlıyoruz.
            </p>
          </FadeUp>
          <FadeUp delay={0.15}>
            <div className="grid sm:grid-cols-3 gap-4 border-t border-espresso/10 pt-8">
              {TRUST.map((t) => (
                <div key={t}>
                  <p className="font-serif text-2xl text-espresso leading-tight">{t}</p>
                </div>
              ))}
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
